export class PhonePrefix {
  name!: string;
  prefix!: string;
  isoCode!: string;
}
